import { createContext, useContext, type ReactNode } from 'react';

import type { PageContext } from '@web-platform/shared-travel-tools-types/src/page-context';

export const PageContextContext = createContext<PageContext | null>(null);

type Props = {
  children: ReactNode;
  value: PageContext;
};

export const PageContextProvider = ({ children, value }: Props) => (
  <PageContextContext.Provider value={value}>{children}</PageContextContext.Provider>
);

export const usePageContext = (): PageContext => {
  const ctx = useContext(PageContextContext);
  if (!ctx) throw new Error('usePageContext must be used within PageContextProvider');
  return ctx;
};
